module.exports = __webpack_public_path__ + "media/application/images/2018/2018-hamburger-5ce6ca33b3f20ae8cdc30a6ecbd17c70.svg";